import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import useBookmakersList from "../hooks/useBookmakersList";
import useUserFilters from "../hooks/useUserFilters";

const BookmakersContext = createContext();
export const useBookmakers = () => useContext(BookmakersContext);

const debounce = (func, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

export const BookmakersProvider = ({ children }) => {
  const { bookmakers, loading, error } = useBookmakersList();
  const { filters, fetchFilters, saveFilter } = useUserFilters();
  const [selectedBookmakers, setSelectedBookmakers] = useState([]);

  useEffect(() => {
    fetchFilters("value-betting", "value-betting-bookmakers");
  }, [fetchFilters]);

  useEffect(() => {
    if (filters && filters.content) {
      setSelectedBookmakers(filters.content);
    }
  }, [filters]);

  const saveBookmakers = useCallback(
    (newBookmakers) => {
      const filterData = {
        key: "value-betting-bookmakers",
        content: newBookmakers,
        category: "value-betting",
      };
      saveFilter(filterData);
    },
    [saveFilter]
  );

  const debouncedSaveBookmakers = useCallback(debounce(saveBookmakers, 1000), [
    saveBookmakers,
  ]);

  const setAndSaveSelectedBookmakers = useCallback(
    (newBookmakers) => {
      setSelectedBookmakers(newBookmakers);
      debouncedSaveBookmakers(newBookmakers);
    },
    [debouncedSaveBookmakers]
  );

  const contextValue = {
    bookmakers,
    loading,
    error,
    selectedBookmakers,
    setSelectedBookmakers: setAndSaveSelectedBookmakers,
  };

  return (
    <BookmakersContext.Provider value={contextValue}>
      {children}
    </BookmakersContext.Provider>
  );
};
